var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import HeaderItem from "./components/HeaderItem.vue";
import UpperSupCheckService from "../../api/UpperSupCheckService";
import EAccountType from '../../enum/EUpperSupAccountType';
import { Loading } from "element-ui";
import { EBillType } from '../../enum/EBillType';
import { toDetail } from '../../helper/util';
import GlobalVue from '../../globalVue';
import applicationDetail from '../applicationOrder/Detail.vue';
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 390;
        _this.detail = {
            order_list: []
        };
        _this.eType = EAccountType;
        return _this;
    }
    Detail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId
        };
        this.service.getDetail(params).then(function (res) {
            loadingInstance.close();
            _this.detail = res.data.data;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail.prototype.mounted = function () {
        if (!this.rowId) {
            return;
        }
        ;
        this.getDetail();
    };
    Detail.prototype.created = function () {
        this.service = UpperSupCheckService.getInstance();
    };
    Detail.prototype.toDetail = function (row) {
        if (row.order_type == 1) {
            toDetail(EBillType.PurToStock, row.order_id, this);
        }
        else if (row.order_type == 2) {
            toDetail(EBillType.PurchaseRefundForUpperSup, row.order_id, this);
        }
        else if (row.order_type == 6) {
            var order_id = row.order_id;
            this.addTab({
                component: applicationDetail,
                title: '查看费用',
                showExist: true,
                name: 'application_order_' + row.order_type,
                cprops: {
                    order_id: order_id,
                },
            });
            window._czc.push(['_trackEvent', '费用管理', '查看费用']);
        }
    };
    Detail.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    Detail = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
